const html = document.documentElement;

export default html;
